export const initialAltriData = {
  data: [],
  lastUpdated: "",
  loading: false,
};

export const initialCreateMenuServiceData = {
  data: {
    destinationTypes: [],
    fdnList: [],
    fdnGroupList: [],
    vocalMessagesList: [],
    odrList: [],
    tdrList: [],
    barringList: [],
    messagiVocaliSuBaseOrigineList: [],
    whiteList: [],
    menuServiceList: [],
    nedList: [],
    fileAudioList: [],
    originAreaList: [],
    currentItemList: [],
  },
  loading: false,
};

export const initialCurrentMenuService = {
  data: {
    customerId: "",
    menuId: "",
    menuName: "",
    announcementId: "",
    menuObjectList: [],
    defaultTipoDestinazione: "",
    defaultDestinazioneId: "",
    defaultRegoleDiApplicazioneId: "",
  },
  loading: false,
};

export const intialCreateOrigineData = {
  data: {
    originAreaList: [],
    destinationTypes: [],
    fdnList: [],
    fdnGroupList: [],
    vocalMessagesList: [],
    odrList: [],
    tdrList: [],
    barringList: [],
    messagiVocaliSuBaseOrigineList: [],
    whiteList: [],
    menuServiceList: [],
    nedList: [],
    currentItemList: [],
  },
  loading: false,
};

export const initialCurrentOrigine = {
  data: {
    customerId: "",
    origineId: "",
    origineName: "",
    odrObjectList: [],
  },
  loading: false,
};

export const initialCreateTempoData = {
  data: {
    ruleItemsList: [],
    fasciaOrariaList: [],
    daysList: [],
    numbersList: [],
    monthsList: [],
    currentItemList: [],
  },
  loading: false,
};

export const initialCurrentTempo = {
  data: {
    customerId: "",
    tempoId: "",
    tempoName: "",
    ruleItems: [],
    currentItemList: [],
  },
  loading: false,
};
